import { useMemo } from "react";

import { FormCategory, getDonationOrTicketingFormLink } from "@simplyk/common";

import { useLocaleContext } from "../../contexts/LocaleContext";
import { useInitialStatus } from "../../hooks/useInitialStatus";
import { useTranslate } from "../../hooks/useTranslate";

import { DashboardLink } from "@/dashboard-design-system/Link";

export const ViewFormLink = () => {
  const { t } = useTranslate();
  const { isoLocale } = useLocaleContext();
  const { firstForm } = useInitialStatus();
  const latestFormLink = useMemo(
    () =>
      firstForm
        ? getDonationOrTicketingFormLink({
            form: {
              id: firstForm.id,
              path: firstForm.path,
              formCategory: firstForm.formCategory as unknown as FormCategory,
              formType: firstForm.formType,
              isPrimaryCampaign: firstForm.isPrimaryCampaign,
              isPrimaryTeam: firstForm.isPrimaryTeam,
            },
            isoLocale,
          })
        : undefined,
    [isoLocale, firstForm]
  );
  return (
    <DashboardLink vibe="reverse" underline="always" href={latestFormLink} target="_blank">
      {t("dashboard", "mobilePopup.viewForm.button")}
    </DashboardLink>
  );
};
